"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _client = _interopRequireDefault(require("./client"));

var _context4 = _interopRequireDefault(require("./context"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _state = require("./state");

var _utils = require("./utils");

var _excluded = ["children", "onRedirectCallback", "skipRedirectCallback"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context5, _context6; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context5 = ownKeys(Object(source), !0)).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var defaultOnRedirectCallback = function defaultOnRedirectCallback(appState) {
  window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};

var AuthProvider = function AuthProvider(opts) {
  var children = opts.children,
      _opts$onRedirectCallb = opts.onRedirectCallback,
      onRedirectCallback = _opts$onRedirectCallb === void 0 ? defaultOnRedirectCallback : _opts$onRedirectCallb,
      skipRedirectCallback = opts.skipRedirectCallback,
      clientOpts = (0, _objectWithoutProperties2.default)(opts, _excluded);

  var _useState = (0, _react.useState)(function () {
    _loglevel.default.debug('[AuthProvider] Config:', clientOpts);

    return (0, _client.default)(clientOpts);
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      client = _useState2[0];

  var _useReducer = (0, _react.useReducer)(_reducer.default, _state.initialAuthState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  (0, _react.useEffect)(function () {
    ;
    (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _yield$client$handleR, appState, user, token;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!((0, _utils.hasAuthParams)() && !skipRedirectCallback)) {
                _context.next = 17;
                break;
              }

              // Check for our own client auth callback params
              _loglevel.default.debug('[AuthProvider] Initiating handleRedirectCallback');

              _context.prev = 3;
              _context.next = 6;
              return client.handleRedirectCallback();

            case 6:
              _yield$client$handleR = _context.sent;
              appState = _yield$client$handleR.appState;

              _loglevel.default.debug('[AuthProvider] handleRedirectCallback appState:', appState);

              onRedirectCallback(appState);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);

              _loglevel.default.warn('[AuthProvider] handleRedirectCallback Error:', _context.t0.message);

            case 15:
              _context.next = 20;
              break;

            case 17:
              // Check for previous auth session
              _loglevel.default.debug('[AuthProvider] Initiating checkSession');

              _context.next = 20;
              return client.checkSession();

            case 20:
              _context.next = 22;
              return client.getTokenSilently();

            case 22:
              token = _context.sent;

              if (!token) {
                _context.next = 27;
                break;
              }

              _context.next = 26;
              return client.getUserProfile(token).catch(function () {
                return null;
              });

            case 26:
              user = _context.sent;

            case 27:
              _loglevel.default.debug('[AuthProvider] User:', user);

              dispatch({
                type: 'INITIALIZED',
                user: user,
                token: token
              });
              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t1 = _context["catch"](0);

              _loglevel.default.error('[AuthProvider] Unhandled Error:', _context.t1);

              dispatch({
                type: 'ERROR',
                error: _context.t1
              });

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 31], [3, 12]]);
    }))();
  }, [client, onRedirectCallback, skipRedirectCallback]);
  var loginWithRedirect = (0, _react.useCallback)(function (opts) {
    return client.loginWithRedirect(opts);
  }, [client]);
  var logout = (0, _react.useCallback)(function (opts) {
    var maybePromise = client.logout(opts);

    if (maybePromise && typeof maybePromise.then === 'function') {
      return maybePromise.then(function () {
        return dispatch({
          type: 'LOGOUT'
        });
      });
    }

    dispatch({
      type: 'LOGOUT'
    });
    return maybePromise;
  }, [client]);
  var getTokenSilently = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(opts) {
      var token;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return client.getTokenSilently(opts);

            case 3:
              token = _context2.sent;

            case 4:
              _context2.prev = 4;
              dispatch({
                type: 'GET_ACCESS_TOKEN_COMPLETE',
                token: token
              });
              return _context2.finish(4);

            case 7:
              return _context2.abrupt("return", token);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0,, 4, 7]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [client]);
  var getUserProfile = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(opts) {
      var user, token;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return client.getTokenSilently(opts);

            case 3:
              token = _context3.sent;

              if (!token) {
                _context3.next = 8;
                break;
              }

              _context3.next = 7;
              return client.getUserProfile(token);

            case 7:
              user = _context3.sent;

            case 8:
              dispatch({
                type: 'GET_USER_PROFILE_COMPLETE',
                user: user
              });
              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);

              _loglevel.default.error('[AuthProvider] ERROR', _context3.t0);

              dispatch({
                type: 'ERROR',
                error: _context3.t0
              });

            case 15:
              return _context3.abrupt("return", user);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [client]);
  return /*#__PURE__*/_react.default.createElement(_context4.default.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      getTokenSilently: getTokenSilently,
      getUserProfile: getUserProfile,
      loginWithRedirect: loginWithRedirect,
      logout: logout
    })
  }, children);
};

AuthProvider.propTypes = {
  clientId: _propTypes.default.string.isRequired,
  redirectUri: _propTypes.default.string.isRequired,
  cacheLocation: _propTypes.default.string,
  useRefreshTokens: _propTypes.default.bool,
  children: _propTypes.default.element,
  maxAge: _propTypes.default.number,
  onRedirectCallback: _propTypes.default.func
};
var _default = AuthProvider;
exports.default = _default;